<template>
  <div
      class="content-image-text"
      :class="{
      'reverse': props.isReverse,
      'white-content': props.isWhiteContent,
      'justify-content-end': props.isReverse,
      'justify-content-start': !props.isReverse,
    }">

    <div
        class="content"
        :class="{ 'small-text-content': props.isContentSmallText }"
        :style="{ width: props.leftWidth }"
    >
      <span v-if="props.title" class="title">{{ props.title }}</span>
      <div v-if="!isRemoveDivider" class="divider"></div>

      <!-- Paragraph tags -->
      <p v-for="(content, index) in props.contents" :key="index" style="font-size: 15.7px;line-height: 22.75px">{{ content }}</p>
      <!-- Paragraph tags -->
    </div>

    <div class="image" :style="{ width: props.rightWidth }">
      <img :src="'/th/plastics' + props.imageUrl" :alt="props.title || 'Content image'" />
      <span v-if="props.credit" class="credit">{{ props.credit }}</span>
    </div>

  </div>
</template>

<script setup>
const props = defineProps([
  'title',
  'credit',
  'contents',
  'imageUrl',
  'leftWidth',
  'rightWidth',
  'isReverse',
  'isWhiteContent',
  'isRemoveDivider',
  'isContentSmallText',
])
</script>

<style scoped>
.content-image-text .content .title {
  display: block;
  margin-bottom: 45px;
}

.content-image-text .content .divider {
  width: 18%;
}

.content-image-text .content p {
  margin-bottom: 1.5em;
  line-height: 1.8;
  letter-spacing: -0.2px;
  font-size: 17px;
}

.content-image-text .content.small-text-content p {
  font-size: 15.2px;
  line-height: 22.8px;
  letter-spacing: 0;
}

.content-image-text:not(.white-content) .content.small-text-content p {
  color: #7A7A7A;
}

.content-image-text:not(.white-content) .content p {
  color: #5a5d67;
}

@media screen and (max-width: 767px) {
  .content-image-text .content,
  .content-image-text .image {
    width: 100% !important;
  }
}

.content-image-text .credit {
  font-family: 'Myriad-Pro', sans-serif;
  font-size: 13px;
  line-height: 1.8;
  letter-spacing: -.2px;

  margin-top: 0;
  padding: 20px 0;
  margin-bottom: 1.5em;
}
</style>
